import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withViewTransitions } from '@angular/router';
import { AuthService } from '@core/services';
import { environment } from '@environment';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  AUTH_SERVICE,
  baseUrlInterceptor,
  jwtInterceptor,
  LANG_SERVICE,
  langInterceptor,
  loggingInterceptor,
  TOKEN_SERVICE,
  TokenService,
} from '@paypoint-frontend/web-core';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { NgxSpinnerModule } from 'ngx-spinner';
import { routes } from './app.routes';
import { LangService } from './core/services/lang.service';
import { INTERCEPTOR_CONFIG } from './core/utils/interceptor.config';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: AUTH_SERVICE, useExisting: AuthService },
    { provide: TOKEN_SERVICE, useExisting: TokenService },
    { provide: LANG_SERVICE, useExisting: LangService },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withXhr(), 
      withInterceptors([
        baseUrlInterceptor(environment),
        loggingInterceptor,
        langInterceptor('', INTERCEPTOR_CONFIG.langInterceptor.skipUrls),
        jwtInterceptor(INTERCEPTOR_CONFIG.jwtInterceptor.skipUrls),
      ])
    ),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: 'api/Content/Lang/',
          suffix: '',
        }),
      }),
      NgxSpinnerModule.forRoot({ type: 'ball-spin-clockwise' }),
    ]),
    // provideAppInitializer(langInitializer),
    provideAnimationsAsync(),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
  ],
};
